import auth from "./middleware/auth";

export default [
  {
    path: "/",
    name: "Employees",
    component: require("@/views/Employees/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":id",
    name: "Employee",
    component: require("@/views/Employees/Item").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":employeeId/activity",
    name: "EmployeeActivity",
    component: require("@/views/Employees/Activity").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":employeeId/documents",
    name: "EmployeeDocuments",
    component: require("@/views/EmployeeDocuments/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":employeeId/documents/:id",
    name: "EmployeeDocument",
    component: require("@/views/EmployeeDocuments/Item").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":employeeId/money",
    name: "EmployeeMoney",
    component: require("@/views/EmployeeMoney/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":employeeId/money/create",
    name: "EmployeeMoneyCreate",
    component: require("@/views/EmployeeMoney/Create").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":employeeId/money/:id",
    name: "EmployeeMoneyItem",
    component: require("@/views/EmployeeMoney/Item").default,
    meta: {
      middleware: auth,
    },
  },
];
